module.exports = __webpack_public_path__ + "img/lock.a9cfcd54.svg";